import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconLock = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.5 0C5.4375 0 3.75 1.6875 3.75 3.75V5.15625C2.625 6.1875 1.875 7.6875 1.875 9.375C1.875 12.4688 4.40625 15 7.5 15C10.5938 15 13.125 12.4688 13.125 9.375C13.125 7.6875 12.375 6.1875 11.25 5.15625V3.75C11.25 1.6875 9.5625 0 7.5 0ZM8.4375 10.0312V12.1875H6.5625V10.0312C6 9.75 5.625 9.09375 5.625 8.4375C5.625 7.40625 6.46875 6.5625 7.5 6.5625C8.53125 6.5625 9.375 7.40625 9.375 8.4375C9.375 9.09375 9 9.75 8.4375 10.0312ZM9.375 4.125C8.8125 3.84375 8.15625 3.75 7.5 3.75C6.84375 3.75 6.1875 3.84375 5.625 4.125V3.75C5.625 2.71875 6.46875 1.875 7.5 1.875C8.53125 1.875 9.375 2.71875 9.375 3.75V4.125Z",
		fill: "currentColor"
	})
});
export default SvgIconLock;
